'use strict';

wbApp.controller('DuePaymentsCtrl', ['$scope', '$modal', '$q', '$window', '$translate', '$timeout',
    '$filter', 'semesterSvc', 'duePaymentsSvc', 'securitySvc', 'messageBoxSvc', 'courseRegistrationSvc', 'tenantSettingSvc',
    'localStorageService', 'accountingBookSvc', 'gridSortSvc',
    function ($scope, $modal, $q, $window, $translate, $timeout, $filter, semesterSvc,
        duePaymentsSvc, securitySvc, messageBoxSvc, courseRegistrationSvc, tenantSettingSvc, localStorageService, accountingBookSvc, gridSortSvc) {

        $scope.semesterDataRange = 1; // 1 - semester, 2 - from to
        $scope.fromDate = moment().subtract(3, 'M').startOf('day').toDate();
        $scope.toDate = moment().startOf('day').toDate();

        if (localStorageService.isSupported)
        {
            $scope.semesterDataRange = localStorageService.get('semesterDataRange') || 1;
        }

        $scope.customFilter = { invoiceForType: [], showAfterDueDateOnly: false };
        $scope.rawDuePayments = [];
        $scope.duePayments = [];

        $scope.accountingBooks = accountingBookSvc.getAllAsync();

        $scope.$watch('customFilter', function (newValue, oldValue) {
            preFilter();
        }, true);

        function preFilter() {
            var now = moment();

            $q.all([$scope.rawDuePayments.$promise, $scope.accountingBooks.$promise]).then(function () {
                var typeIDs = _.values($scope.customFilter.invoiceForType);
                var accountingBookIDs = _.values($scope.customFilter.accountingBooks);
                var showAfterDueDateOnly = $scope.customFilter.showAfterDueDateOnly;
                $scope.duePayments.length = 0;
                $scope.duePayments.push.apply($scope.duePayments,
                    _.filter($scope.rawDuePayments, function (o) {
                        var result = true;
                        if (typeIDs.length > 0) {
                            result = _.includes(typeIDs, o.typeID);
                        }

                        if (accountingBookIDs.length > 0) {
                            result = result && _.includes(accountingBookIDs, o.accountingBookID);
                        }

                        if (showAfterDueDateOnly) {
                            
                            result = result && o.claimOverdue;
                            // hasAmortizationSchedule
                            //   ? result && o.priceByAmortizationSchedule != o.payments 
                            //   : result && moment(o.dueDate).isBefore(now);
                        }

                        return result;
                    })
                );
            });
        }

    $scope.onDataRangeChanged = function () {
        if (localStorageService.isSupported) {
            localStorageService.set('semesterDataRange', $scope.semesterDataRange);
        }

        if ($scope.semesterID != null) {
            loadData();
        }

        if ($scope.gridSettings.gridInstance) {
            if ($scope.semesterDataRange === 1) {
                $scope.gridSettings.gridInstance.columnOption("semesterColumn", "visible", false);
            } else {
                $scope.gridSettings.gridInstance.columnOption("semesterColumn", "visible", true);
            }
        }
    }

    function loadData() {
        if ($scope.semesterDataRange === 1) {
            $scope.rawDuePayments = duePaymentsSvc.getAllBySemesterIDAsync(
                $scope.semesterID != null ? $scope.semesterID : null, true);
        } else {
            $scope.rawDuePayments = duePaymentsSvc.getAllByDateRangeAsync(
                $scope.fromDate, $scope.toDate, true);
        }
        preFilter();
    }

    $q.all([semesterSvc.getDefaultAsync()])
    .then(function (data) {
        if (data[0]) {
            $scope.semesterID = data[0].id;
        }

        loadData();
    });

    $scope.$on('refreshData', function (e, data) {
        if ($scope.semesterID) {
            loadData();
            setSelectedDuePayment(null);
        }
    });

    $scope.onSemesterChange = function (semesterID) {
        if (semesterID) {
            loadData();           
            setSelectedDuePayment(null);
        }
    }

    var addPaymentPromise = $modal({
        templateUrl: 'finance/payments/payments-detail.html',
        show: false,
        scope: $scope.$new()
    });

    function addPayment(data) {
        addPaymentPromise.$scope.isAddDuePayment = true;
        addPaymentPromise.$scope.paymentDetail = {
            paymentID: 0,
            invoiceForType: data.typeID,
            invoiceID: data.invoiceID,
            amount: data.value,
            selectedDate: data.date,
        };

        addPaymentPromise.$promise.then(function () {
            addPaymentPromise.$scope.detailError = null;
            addPaymentPromise.$scope.onSave = function () {
                loadData();
                setSelectedDuePayment(null);
            }

            addPaymentPromise.show();
        });
    }



    function setSelectedDuePayment(duePayment) {
        if ($scope.selectedDuePayment !== duePayment) {
            $scope.selectedDuePayment = duePayment;
            $scope.$broadcast('selectedDuePaymentChanged', duePayment);
        }
    }

    $scope.icons = [{
        value: 1,
        label: $translate.instant('TXT_LAB_COURSE')
    }, {
        value: 2,
        label: $translate.instant('TXT_LAB_ACTION_SINGULAR')
    }, {
        value: 3,
        label: $translate.instant('TXT_LAB_KINDERGARTEN')
    }, {
        value: 4,
        label: $translate.instant('TXT_LAB_RESERVATION')
    }];

    $scope.gridSettings = {
        name: 'duePayments',
        columns: [
            {
                name: 'semesterColumn',
                dataField: 'semesterID',
                caption: $translate.instant('TXT_LBL_SEMESTER'),
                dataType: 'string',
                width: '120px',
                calculateCellValue: function (rowData) {
                    return $filter('semester')(rowData.semesterID);
                },
                visible: $scope.semesterDataRange === 2
            },
            {
                dataField: 'studentFullName', caption: $translate.instant('TXT_LBL_STUDENT'), dataType: 'string', width: '160px',
                calculateSortValue: function (data) { return gridSortSvc.sortHumanFullName2(data, 'studentFullName') }
            },
            { dataField: 'invoiceNo', caption: $translate.instant('TXT_LBL_INVOICE_NO'), dataType: 'string', width: '90px' },
            {
                dataField: 'typeID',
                caption: $translate.instant("TXT_LBL_TYPE"),
                dataType: 'string',
                calculateCellValue: function (rowData) {
                    return $filter('invoiceForType')(rowData.typeID);
                },
                width: '55px'
            },
            { dataField: 'subject', caption: $translate.instant('TXT_LBL_SUBJECT'), dataType: 'string', sortOrder: 'asc' },
            { dataField: 'notes', caption: $translate.instant('TXT_NOTE'), dataType: 'string' },
            {
                dataField: 'hasAmortizationSchedule',
                caption: $translate.instant('TXT_TAB_AMORTIZATION_SCHEDULE'),
                dataType: 'boolean',
                trueText: '<i class="fa fa-calendar" aria-hidden="true"></i>',
                falseText: ' ',
                encodeHtml: false,
                showEditorAlways: false,
                width: '40px',
                visible: tenantSettingSvc.settings.enableAmortizationSchedules,
            },
            { dataField: 'dueDate', caption: $translate.instant('TXT_LBL_DUE_DATE'), dataType: 'date', width: '90px' },
            { dataField: 'price', caption: $translate.instant('TXT_LBL_PRICE'), dataType: 'number', format: { type: 'currency', precision: 2 }, width: '100px' },
            { dataField: 'payments', caption: $translate.instant('TXT_LBL_PAYMENTS'), dataType: 'number', format: { type: 'currency', precision: 2 }, width: '100px' },
            { dataField: 'arrear', caption: $translate.instant('TXT_LBL_ARREAR'), dataType: 'number', format: { type: 'currency', precision: 2 }, width: '100px' }
        ],        
        onRowPrepared: function (e) {
            if (e.rowType == "data") {
                var data = e.component.getKeyByRowIndex(e.rowIndex);
                if (data.invoiceNotInSync) {
                    e.rowElement.addClass('text-danger');
                }
            }
        },
        customCommands: [{
            text: $translate.instant('TXT_MENU_CREATE_PAYMENT'),
            isVisible: function (row) { return securitySvc.isInRole('Payment.Insert'); },
            callback: function (row) { addPayment(row); }
        },{
            text: $translate.instant('TXT_MENU_PRINT_INVOICE'),
            isVisible: function (row) {
                return securitySvc.isInRole('CourseRegistration.PrintInvoice') && securitySvc.isInRole('Reports');
            },
            callback: function (row) { $scope.onPrintInvoice(row.invoiceID); }
        },
        {
            text: $translate.instant('TXT_MENU_SEND_DUE_PAYMENT_NOTIF'),
            callback: function (row) { $scope.onDuePaymentNotification(row); }
        },
        {
            text: $translate.instant('TXT_MENU_REMOVE_FROM_COURSE'),
            isVisible: function (row) {
                return securitySvc.isInRole('CourseRegistration.Delete') && row.typeID === 1;
            },
            callback: function (row) { $scope.removeFromCourse(row); }
        }]
    }


    $scope.onRowSelected = function (data) {
        setSelectedDuePayment(data);
    }

    $scope.expectedPricePop = {
        title: 'Očekávaná cena',
        content: $translate.instant('TXT_LBL_EXPECTED_PRICE_MISMATCH')
    }

    function removeFromCourseImpl(data) {
        courseRegistrationSvc.remove(
            { courseRegistrationID: data.typeReferenceID },
            1 /* Courses */,
            function () {
                loadData();
            });
    }

    $scope.removeFromCourse = function (data) {
        messageBoxSvc.showMessageDlg({
            title: 'TXT_TITLE_CONFIRM_DELETE',
            message: $translate.instant('TXT_CONFIRM_REMOVE_FROM_COURSE').f(data.studentFullName, data.subject),
            buttons: [{
                text: 'TXT_BTN_NO'
            }, {
                text: 'TXT_BTN_YES',
                callback: function () { return removeFromCourseImpl(data); }
            }]
        });
    }
    
    $scope.onPrintInvoice = function(invoiceID) {
        $window.open('/Admin/Report/Invoice?ReportID=' + invoiceID + '&ReportIDType=1',
            '_blank', 'width=1000,height=500,toolbar=no,resizable=yes,location=no,directories=no,status=no,menubar=no,copyhistory=no');
    }

    $scope.onUpdateInvoice = function (invoiceID) {
        invoiceDetailDialogPromise.$promise.then(function() {
            invoiceDetailDialogPromise.$scope.invoiceID = invoiceID;
            invoiceDetailDialogPromise.show();
        });
    }

    $scope.onDuePaymentNotification = function (row) {
        duePaymentsSvc.sendRequestForPayment(
            row.invoiceID,
            row.typeID,
            row.typeReferenceID,
            row.typeReference2ID,
            row.parentID,
            row.isReccuring);
    }

    $scope.onFilterApplied = function (filteredRows) {
        $scope.$broadcast('filterApplied', filteredRows);
    }

    $scope.tabs = [
    {
        title: 'TXT_DETAIL',
        template: "finance/due-payments/due-payments-tabs/detail.html"
    }, {
        title: 'TXT_FILTER_SUMMARY',
        template: "finance/due-payments/due-payments-tabs/summary.html"
    }, {
        title: 'TXT_USER_PAYMENTS',
        template: "finance/due-payments/due-payments-tabs/user-payments.html"
    }, {
        title: 'TXT_USER_INVOICES',
        template: "finance/due-payments/due-payments-tabs/user-invoices.html"
    }, {
        title: 'TXT_LBL_PAYMENTS',
        template: "finance/due-payments/due-payments-tabs/payments.html"
    }];

    if (tenantSettingSvc.settings.enableAmortizationSchedules) {
        $scope.tabs.push({
            title: 'TXT_TAB_AMORTIZATION_SCHEDULE',
            template: "finance/due-payments/due-payments-tabs/amortization-schedule.html"
        });
    }

    $scope.tabs.activeTab = 0;

    $scope.$watch('tabs.activeTab', function (newValue, oldValue) {
        $scope.$broadcast('activeTabChanged', { activeTab: newValue, oldValue: oldValue });
    });


    var invoiceDetailDialogPromise = $modal({
        templateUrl: 'finance/invoices/invoices-detail.html',
        show: false,
        scope: $scope.$new()
    });
}]);